import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { AddToWishlistRequest } from '../api/wishlist/addtowishlist/addtowishlistrequest';
import { AddToWishlistResponse, AddToWishlistResponseDtoImpl } from '../api/wishlist/addtowishlist/addtowishlistresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class AddToWishlistAPIProcessorImpl extends SixdeeCRBTAPIProcessor<AddToWishlistRequest, AddToWishlistResponse>
{
    private LOGGER: Logger = LogManager.getLogger(AddToWishlistAPIProcessorImpl.name);
    execute(request: AddToWishlistRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        this.LOGGER.log("onSuccess() invoked");

        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new AddToWishlistResponseDtoImpl(APIFeatures.ADD_TO_WISHLIST, "Add To Wishlist Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new AddToWishlistResponseDtoImpl(APIFeatures.ADD_TO_WISHLIST, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

        this.getAPIFailure(new AddToWishlistResponseDtoImpl(APIFeatures.ADD_TO_WISHLIST, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/addtowishlistapiprocessor.tsx